export default __webpack_public_path__ + "assets/footer-bg.1a84c1.png";